import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import parse from "html-react-parser";
import "./index.css";

const PlayButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 69 69" fill="none">
    <circle cx="34.2143" cy="34.2143" r="34.2143" fill="#FF541C"/>
    <path d="M47.5454 31.616C49.5454 32.7707 49.5454 35.6574 47.5454 36.8121L29.8006 47.0571C27.8006 48.2118 25.3006 46.7684 25.3006 44.459L25.3006 23.9691C25.3006 21.6597 27.8006 20.2163 29.8006 21.371L47.5454 31.616Z" fill="white"/>
  </svg>
);

const getVideoId = (url) => {
  if (!url) return "";
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|live\/|shorts\/))([-\w]+)/);
  return match ? match[1] : "";
};

const SlideSection = ({ data }) => {
  const [playing, setPlaying] = useState(false);
  const imgPath = process.env.REACT_APP_IMAGES;

  if (!data) return null;

  const isTextLeft = data.layout === "text-left";
  const videoId = getVideoId(data.videoUrl);

  const textCol = (
    <Col lg={6} key="text" className="slide-text-col">
      <div className="slide-badge-row">
        {!data.noBadgeSquare && <span className="slide-badge-square" />}
        <span className="slide-badge">{parse(data.badge)}</span>
      </div>
      <h2 className={`slide-heading${data.leftBar ? ' slide-heading-left-bar' : ''}`}>{parse(data.heading)}</h2>
      {data.paragraphs && data.paragraphs.map((p, i) => (
        <p className="slide-paragraph" key={i}>{parse(p)}</p>
      ))}
      {data.bottomQuote && (
        <p className="slide-bottom-quote">{parse(data.bottomQuote)}</p>
      )}
    </Col>
  );

  const videoCol = (
    <Col lg={6} key="video" className="slide-video-col">
      <div className={`slide-video-wrapper${data.noGlow ? '' : ' video-glow'}`}>
        {!data.noGlow && <><span className="video-glow-blob-1" /><span className="video-glow-blob-2" /></>}
        {data.autoVideo ? (
          <video
            className="slide-auto-video"
            src={`${imgPath}${data.autoVideo}`}
            poster={`${imgPath}${data.thumbnail}`}
            autoPlay
            loop
            muted
            playsInline
          />
        ) : data.noVideo ? (
          <img
            src={`${imgPath}${data.thumbnail}`}
            alt={data.badge}
            className="slide-thumbnail"
            loading="lazy"
          />
        ) : (
          <div className="slide-thumb-click" onClick={() => !playing && setPlaying(true)} role="button" tabIndex={0} aria-label="Play video">
            <img
              src={`${imgPath}${data.thumbnail}`}
              alt={data.badge}
              className="slide-thumbnail"
              loading="lazy"
            />
            {!playing && (
              <span className="slide-play-btn">
                <PlayButton />
              </span>
            )}
            {playing && (
              <>
                <div className="video-loading-spinner" />
                <iframe
                  className="slide-iframe video-iframe-overlay"
                  src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                  title={data.badge}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  frameBorder="0"
                />
                <button className="slide-close-btn" onClick={(e) => { e.stopPropagation(); setPlaying(false); }} aria-label="Close video">✕</button>
              </>
            )}
          </div>
        )}
      </div>
    </Col>
  );

  return (
    <section className="slide-section section-spacing" id={data.id} style={data.topPadding ? {paddingTop:'4rem'} : undefined}>
      <Container>
        <Row className="align-items-center">
          {isTextLeft ? [textCol, videoCol] : [videoCol, textCol]}
        </Row>
        {data.stats && (
          <Row className="slide-stats-row">
            {data.stats.map((stat, i) => (
              <Col key={i} lg={4} xs={4} className="slide-stat">
                <p className="slide-stat-value">{parse(stat.value)}</p>
                <p className="slide-stat-label">{parse(stat.label)}</p>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </section>
  );
};

export default SlideSection;
